// @flow
import { APP_BRAND } from '@alphaott/smart-tv-config'

const params = new URLSearchParams(window.location.search)

export const brandName: ?string = params.get('brand') || APP_BRAND
